import Vue from 'vue';
import {
  clone, findIndex,
} from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';

const data = {
  skillsDirectories: [],
  fething: false,
};

const actions = {
  fetchSkillsDirectories({ commit }) {
    commit(SET_FETCHING);
    return api.getSkillsDirectories().then((res) => {
      commit('SET_SKILLS_DIRECTORIES', res);
    })
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  getSkillsDirectoriesForTransfer(_, channelId) {
    return api.getSkillsDirectoriesForTransfer(channelId).then((res) => res)
      .catch((err) => {
        throw err;
      });
  },
  createSkillsDirectory({ commit }, { model }) {
    return api.createSkillsDirectory(model).then((res) => {
      commit('ADD_SKILLS_DIRECTORY', res);
    });
  },
  updateSkillsDirectory({ commit }, { id, model }) {
    return api.updateSkillsDirectory(id, model).then((res) => {
      commit('UPDATE_SKILLS_DIRECTORY', res);
    });
  },
  deleteSkillsDirectory({ commit }, id) {
    commit(SET_FETCHING);
    return api.deleteSkillsDirectory(id)
      .then(() => commit('DELETE_SKILLS_DIRECTORY', id))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  getSkillDirectoryForTransfer(_, { directoryId, channelIdentifier, channelId }) {
    return api.getSkillDirectoryForTransfer({ directoryId, channelIdentifier, channelId }).then((res) => res);
  },
};

const mutations = {
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SET_SKILLS_DIRECTORIES(state, payload) {
    state.skillsDirectories = payload;
    mutations.SET_STOP_FETCHING(state);
  },
  UPDATE_SKILLS_DIRECTORY(state, res) {
    const { id } = res;
    const { skillsDirectories } = state;
    const index = findIndex(skillsDirectories, { id });
    Vue.set(skillsDirectories, index, { ...skillsDirectories[index], ...res });
  },
  DELETE_SKILLS_DIRECTORY(state, id) {
    const { skillsDirectories } = state;
    Vue.delete(skillsDirectories, findIndex(skillsDirectories, { id }));
  },
  ADD_SKILLS_DIRECTORY(state, res) {
    state.skillsDirectories.push(clone(res));
  },
};

const getters = {
  getSkillsDirectoryById(state) {
    const { skillsDirectories } = state;
    return (id) => (skillsDirectories[findIndex(skillsDirectories, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  mutations,
  getters,
  actions,
};

export default store;
